<template>
  <div class="vd-gl-content">
    <a-row type="flex" class="vd-table-head">
      <a-col flex="auto" class="vd-table-name"> 角色组列表</a-col>
      <a-col class="vd-table-tool">
        <a-button type="primary" icon="plus" @click="createRoles">
          新建
        </a-button>
        <a-divider type="vertical" />
        <a-icon class="common-icon" type="reload"></a-icon>
      </a-col>
    </a-row>
    <a-table
      :data-source="tableRole"
      :defaultExpandAllRows="true"
      :pagination="false"
      row-key="id"
      size="small"
    >
      <a-table-column align="center" title="ID" data-index="id" />
      <a-table-column align="center" title="父级ID" data-index="pid" />
      <a-table-column title="角色组" data-index="name">
        <template slot-scope="text, record">
          <template v-if="record.id !== 1">
            <span
              :style="{ 'padding-left': (record.deep - 1) * 9 + 'px' }"
            ></span>
            <template v-if="record.last">
              {{ ' └ ' + text }}
            </template>
            <template v-else>
              {{ ' ├ ' + text }}
            </template>
          </template>
          <template v-else>
            {{ text }}
          </template>
        </template>
      </a-table-column>
      <a-table-column align="center" title="状态" data-index="status">
        <template slot-scope="text">
          <span>
            <a-tag color="green" v-if="text === 1">正常</a-tag>
            <a-tag v-else>禁用</a-tag>
          </span>
        </template>
      </a-table-column>
      <a-table-column align="center" title="操作" data-index="action">
        <template slot-scope="text, record">
          <template v-if="record.id !== 1">
            <a-tooltip title="修改">
              <a-icon
                class="common-icon"
                type="edit"
                @click="changeRole(record)"
              />
            </a-tooltip>
            <a-popconfirm
              ok-text="是"
              cancel-text="否"
              @confirm="removeRole(record.id)"
            >
              <template slot="title">
                <p>确认删除?</p>
                <p>包括下级角色组</p>
              </template>
              <a-icon class="common-icon" type="delete" />
            </a-popconfirm>
          </template>
        </template>
      </a-table-column>
    </a-table>
  </div>
</template>

<script>
import { getRoleApi, role_del } from '@/api/auth'
import { menu_list } from '@/api/menu'
export default {
  name: 'Role',
  data() {
    return {
      // a-tree 默认展开所有树节点
      replaceFields: { title: 'name', key: 'id' },
      // data
      tableRole: [],
      menuListTree: [],
    }
  },
  created() {
    menu_list().then((res) => {
      if (res.code === 1) {
        this.menuListTree = res.list
      }
    })
    this.getData()
  },
  methods: {
    removeRole(id) {
      role_del({ id }).then((res) => {
        if (res.code === 1) {
          this.$message.warning(res.msg)
          this.getData()
        } else {
          this.$message.warning(res.msg)
        }
      })
    },
    createRoles() {
      this.$router.push({ path: '/auth/role/modify' })
    },
    changeRole(record) {
      this.$router.push({ name: 'authRoleModify', params: record })
    },
    getData() {
      getRoleApi().then((res) => {
        if (res.code === 1) {
          this.tableRole = res.list
        } else {
          this.$message.warning(res.msg)
        }
      })
    },
  },
}
</script>

<style scoped></style>
